import type { MapId } from '~/_shared/types/map';
import { isDataLayersArtificialBoundaryTerritoryGroup } from '~/sidebar/sidebarApps/mapTools/dataLayersTool/dataLayersTool.helpers';
import type { BoundaryGroupId } from '~/store/boundaries/boundaryIdentifier.type';
import type { DemographicIdCode } from '~/store/boundaryGroups/boundaryGroups.repository';
import { BoundaryTerritoryType } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroup.type';
import type {
  BoundaryTerritoryGroup, BoundaryTerritoryGroupStyle,
} from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.state';
import type { DataLayerId } from '~/store/mapSettings/data/dataLayers/mapSettingsDataLayers.state';

export const isBTGForDataLayerDemographic = ({
  boundaryGroupId,
  dataLayerId,
  demographic,
  boundaryTerritoryGroup,
  mapId,
  numberOfRanges,
  gradientColors,
}: Readonly<{
  boundaryGroupId: Maybe<BoundaryGroupId>;
  dataLayerId: DataLayerId;
  demographic: DemographicIdCode;
  boundaryTerritoryGroup: BoundaryTerritoryGroup;
  mapId: MapId | null;
  numberOfRanges: number;
  gradientColors: BoundaryTerritoryGroupStyle['gradientColors'];
}>): boolean => {
  const existingStyle = boundaryTerritoryGroup.settings.style;
  return boundaryTerritoryGroup.mapId === mapId
    && isDataLayersArtificialBoundaryTerritoryGroup(boundaryTerritoryGroup)
    && boundaryTerritoryGroup.boundaryGroupId === boundaryGroupId
    && boundaryTerritoryGroup.settings.connectedEntityData?.id === dataLayerId
    && boundaryTerritoryGroup.settings.boundaryTerritoryType === BoundaryTerritoryType.Demographic
    && boundaryTerritoryGroup.settings.demographicId === demographic
    && boundaryTerritoryGroup.settings.rangesCount === numberOfRanges
    && existingStyle
    && existingStyle.gradientColors.high === gradientColors.high
    && existingStyle.gradientColors.medium === gradientColors.medium
    && existingStyle.gradientColors.low === gradientColors.low
    && existingStyle.gradientColors.minimal === gradientColors.minimal;

};
